"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Options for replacing tags using dollar signs and square brackets (`$[` `]$`).
 * Matches tags of the form `$[variable]$` in the text.
 * @example
 * // Example usage:
 * const text = 'Hello $[variable]$';
 * const result = replaceTags(text, { variable: 'world' }, DollarSignsWithSquareBrackets);
 * console.log(result); // Output: 'Hello world'
 */
var DollarSignsWithSquareBrackets = {
    name: "Dollar Signs With Square Brackets",
    openingTag: "$[",
    closingTag: "]$",
    tagPattern: /\$\[([^\]]*(?:](?!\$)[^\]]*)*)\]\$/g,
    tagStartPattern: /^\$\[/,
    tagEndPattern: /\]\$$/,
};
exports.default = DollarSignsWithSquareBrackets;
